'use strict'

import { InitWishListEvent } from 'Modules/wishList'
import { InitialiserWishlistInLocalStorage } from 'Modules/gestionLocalStorage'
import master from 'Modules/master'
import carousel from 'Modules/carousel'

carousel.activerCarrouselCrossSell()

InitialiserWishlistInLocalStorage(false)

InitWishListEvent()

master.process()

/**
 * Page Blog
 */
$(document).ready(() => {
    handleHashChange()
})

$('.blog__categories-wrapper a').on('click', function (e) {
    e.preventDefault()

    if (!$(this).attr('data')) {
        return
    }

    location.hash = $(this).attr('data')
})

onhashchange = () => handleHashChange()

const handleHashChange = () => {
    const hash = location.hash.replace('#', '')

    $('.blog__categories-wrapper a').removeClass('blog__categories--active')

    if (!hash) {
        $('.blog__categories-wrapper a:first').addClass('blog__categories--active')
    } else {
        $(`.blog__categories-wrapper a[data="#${hash}"]`).addClass('blog__categories--active')
    }

    $('.thumbnail-card').each(function () {
        if (!hash) {
            $(this).show()
            return
        }

        const category = $(this).data('category')

        if (category !== hash) {
            $(this).hide()
            return
        }

        $(this).show()
    })
}

/**
 * Thumbnail Article
 */
$('.thumbnail-card, .carrousel > a').on('click', function (e) {
    const url = $(this).data('url')

    if (!url) {
        return
    }

    e.preventDefault()

    location.href = url
})
